import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EbenProcessInstance, EbenTaskDetail } from '@alf-nx-workspace/eben/interfaces';
import { WorkflowService } from '@alf-nx-workspace/shared/utils';
import { WorkflowServiceModel } from '@alf-nx-workspace/flow/interfaces';

@Component({
  selector: 'shared-ui-process-priority',
  templateUrl: './process-priority.component.html',
  styleUrls: ['./process-priority.component.scss'],
})
export class ProcessPriorityComponent implements OnChanges {
  @Input()
  process: EbenProcessInstance;

  @Input()
  task: EbenTaskDetail;

  public highPriorityTooltip: string;
  public longRunningTooltip: string;

  constructor(public workflowService: WorkflowService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.process.ended) {
      return;
    }

    const workflowServiceModel: WorkflowServiceModel = this.workflowService.getServiceByProcessDefinitionKey(
      this.process.processDefinitionKey
    );

    if (workflowServiceModel) {
      this.highPriorityTooltip = workflowServiceModel.isHighPriority(this.process);
      this.longRunningTooltip = workflowServiceModel.isLongRunning(this.process, this.task);
    }

    if(this.highPriorityTooltip) {
      return;
    }

    if (this.task && this.task.dueDate) {
      const dueDate: Date = new Date(this.task.dueDate);
      const inSevenDays: Date = new Date();
      inSevenDays.setDate(inSevenDays.getDate() + 7);

      if (dueDate < inSevenDays) {
        this.highPriorityTooltip = 'TASK.DUE_DATE.WARNING';
      }
    }
  }
}
